import mixin from './mixin'
export default{
    mixins:[mixin],
    data(){
        return {
            formData: {
                orgRoleName: "WAREHOUSE", //MERCHANT FORWARDER WAREHOUSE
                menuLabel:"fbb-web.appoint.manage_app_list",
                search: {
                    EQ_status: null,
                },
                sidx: 'updatedAt',
            },
        }
    },
    computed: {
        TabsData() {
            return [
                {
                    name: "ALL",
                    key: "EQ_status",
                    val: null,
                    spanKey: "ALL",
                },
                {
                    name: "Pending",
                    key: "EQ_status",
                    val: "1",
                    theme: "info",
                    spanKey: "Pending to Approval",
                },
                {
                    name: "Approved",
                    key: "EQ_status",
                    val: "2",
                    theme: "success",
                    spanKey: "Approved",
                },
                {
                    name: "Rejected",
                    key: "EQ_status",
                    val: "3",
                    theme: "warning",
                    spanKey: "Rejected",
                },
                {
                    name: "Arrived",
                    key: "EQ_status",
                    val: "6",
                    spanKey: "Arrived",
                    theme: "primary"
                },
                {
                    name: "Unloaded",
                    key: "EQ_status",
                    val: "4",
                    spanKey: "Unloaded",
                },
                {
                    name: "Cancelled",
                    key: "EQ_status",
                    val: "5",
                    spanKey: "Cancelled",
                },

            ];
        },
    },
}
